import { render, staticRenderFns } from "./template-nav.vue?vue&type=template&id=1b87e7e2"
import script from "./template-nav.vue?vue&type=script&lang=js"
export * from "./template-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports